module.exports = __webpack_public_path__ + "__static/site-1751025561283/img/vector-bg.5d4c4ee9.svg";